import { createFileRoute } from '@tanstack/react-router'
import { ProcessDataWorkbench } from 'pages/processData/ProcessDataWorkbench'
import { processDataDashboardSearchSchema } from 'routes/process-data/-searchParams'

const RouteComponent = () => {
  const { orgId, siteId, alertId, mode } = Route.useSearch()

  return (
    <ProcessDataWorkbench
      orgId={orgId}
      siteId={siteId}
      alertId={alertId}
      mode={mode}
    />
  )
}

export const Route = createFileRoute('/process-data/')({
  component: RouteComponent,
  validateSearch: processDataDashboardSearchSchema,
  staticData: {
    title: 'Process Data',
    layout: {
      enableScrolling: false,
    },
  },
})
